import {
  LicenseType,
  Member,
  OrganizationType,
  VendorProductType,
  PriceType,
  Campaign,
} from "../../../utils/types";

export const delay = (ms: any) => new Promise((res) => setTimeout(res, ms));
export const getTime = (date: any) => {
  const test = isValidDate(new Date(date));
  if (!test) {
    let newFromMilliseconds = new Date(Number(date)).toString();
    return newFromMilliseconds;
  } else {
    return new Date(date).toString();
  }
};
export const isValidDate = (d: any) => {
  // @ts-ignore
  return d instanceof Date && !isNaN(d);
};
export const isString = (color: any) => color && typeof color === "string";
export const validateHex = (color: any) => {
  if (isString(color)) {
    const regex = /^#([\da-f]{3}){1,2}$|^#([\da-f]{4}){1,2}$/i;
    if (regex.test(color)) {
      return "ffffff";
    } else {
      if (color === "0") {
        return "000000";
      } else {
        return color;
      }
    }
  }
};
export const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(" ");
};
export const getLicensorName = (licensor: string) => {
  switch (licensor) {
    case "affinity":
      return "Affinity";
    case "nonaffinity":
      return "CLC";
    case "brandr":
      return "BrandR";
    case "exemplar":
      return "Exemplar";
    default:
      return "unknown";
  }
};

export const getStatusColor = (license: LicenseType) => {
  /*
  id: 1, name: On Hold
  id: 2, name: Pending Licensor Review
  id: 3, name: Pending Admin Review
  id: 7, name: Rejected By Licensor
  id: 8, name: Rejected By Admin
  id: 9, name: Final Rejected By Admin
  id: 12, name: Approved By Admin With Changes
  id: 13, name: Approved By Licensor With Changes
  id: 14, name: Approved By Admin
  id: 15, name: Approved By Licensor
  */
  if (license?.licensor === "affinity") {
    switch (license?.affinity_status_id) {
      case "0":
        return "bg-blue-200 p-2";
      case "1":
        return "bg-amber-200 p-2";
      case "2":
        return "bg-blue-600 p-2";
      case "3":
        return "bg-blue-600 p-2";
      case "7":
        return "bg-red-700 p-2";
      case "8":
        return "bg-red-700 p-2";
      case "9":
        return "bg-red-700 p-2";
      case "12":
        return "bg-emerald-500 p-2";
      case "13":
        return "bg-emerald-500 p-2";
      case "14":
        return "bg-emerald-500 p-2";
      case "15":
        return "bg-emerald-500 p-2";
      default:
        return "bg-white p-2";
    }
  }
  if (license?.licensor === "nonaffinity") {
    if (license?.status === "complete") {
      return "bg-emerald-500 p-2";
    }
  }
  return "bg-white p-2";
};
export const priorityOptions = [
  { name: "Urgent", number: 0 },
  { name: "P1", number: 1 },
  { name: "P2", number: 2 },
  { name: "P3", number: 3 },
  { name: "P4", number: 4 },
  { name: "P5", number: 5 },
];

export function swapDynamicWordsForListing({
  str,
  campaign,
  athlete,
  college,
  organization,
  catalogProduct,
  prices,
}: {
  str: String;
  campaign: Campaign | null;
  athlete: Member | null;
  college: OrganizationType | null;
  organization: OrganizationType | null;
  catalogProduct: VendorProductType | null;
  prices: PriceType[];
}) {
  if (!str) {
    return str;
  }
  let result: string[] = [];
  if (!str) {
    return str;
  }
  const split = str.split(/([^{}]*)(\{.*?\})/g).filter(Boolean);
  for (let i = 0; i < split.length; i++) {
    const word = split[i].replace(/[{}]/g, "");

    if (word === " - ") {
      result.push(word);
      continue;
    }

    const prefix = word.split("-")[0];
    const key = word.split("-")[1];
    if (!key || !prefix) {
      if (!word) {
        result.push("undefined");
        continue;
      }
      result.push(word);
    }

    if (prefix === "campaign") {
      if (!campaign) {
        continue;
      }
      if (key === "id") {
        const val = campaign.id ? campaign.id : "";
        result.push(val);
      }
      if (key === "title") {
        const val = campaign.title ? campaign.title : "";
        result.push(val);
      }
      if (key === "description") {
        const val = campaign.description ? campaign.description : "";
        result.push(val);
      }
    }

    if (prefix === "catalog") {
      if (!catalogProduct) {
        continue;
      }
      if (key === "brand") {
        const val = catalogProduct.brand ? catalogProduct.brand : "";
        result.push(val);
      }
      if (key === "model") {
        const val = catalogProduct.model ? catalogProduct.model : "";
        result.push(val);
      }
      if (key === "product_type") {
        const val = catalogProduct.product_type
          ? catalogProduct.product_type
          : "";
        result.push(val);
      }
      if (key === "description") {
        const val = catalogProduct.description
          ? catalogProduct.description
          : "";
        result.push(val);
      }
      if (key === "color") {
        const val = catalogProduct.color ? catalogProduct.color : "";
        result.push(val);
      }
      if (key === "sizes") {
        const sizeTable = constructSizeTableHTML({ prices });
        result.push(sizeTable);
      }
    }

    if (prefix === "athlete") {
      if (!athlete) {
        continue;
      }
      if (key === "activity") {
        const val = athlete.activity ? athlete.activity : "";
        result.push(val);
      }
      if (key === "sports") {
        const val = athlete.sports ? athlete.sports : "";
        result.push(val);
      }
      if (key === "salesforce_id") {
        const val = athlete.salesforce_id ? athlete.salesforce_id : "";
        result.push(val);
      }
      if (key === "hometown") {
        const val = athlete.hometown ? athlete.hometown : "";
        result.push(val);
      }
      if (key === "full_name") {
        const val = athlete.full_name ? athlete.full_name : "";
        result.push(val);
      }
      if (key === "college") {
        const val = athlete.college ? athlete.college : "";
        result.push(val);
      }
      if (key === "last_name") {
        const val = athlete.last_name ? athlete.last_name : "";
        result.push(val);
      }
      if (key === "number") {
        const val = athlete.number ? athlete.number : "";
        result.push(val);
      }
      if (key === "first_name") {
        const val = athlete.first_name ? athlete.first_name : "";
        result.push(val);
      }
      if (key === "position") {
        const val = athlete.position ? athlete.position : "";
        result.push(val);
      }
    }

    if (prefix === "organization") {
      if (!organization) {
        continue;
      }
      if (key === "motto_short") {
        const val = organization.motto_short ? organization.motto_short : "";
        result.push(val);
      }
      if (key === "motto") {
        const val = organization.motto ? organization.motto : "";
        result.push(val);
      }
      if (key === "motto_long") {
        const val = organization.motto_long ? organization.motto_long : "";
        result.push(val);
      }
      if (key === "colloquial_phrase") {
        const val = organization.colloquial_phrase
          ? organization.colloquial_phrase
          : "";
        result.push(val);
      }
      if (key === "colloquial_name") {
        const val = organization.colloquial_name
          ? organization.colloquial_name
          : "";
        result.push(val);
      }
      if (key === "salesforce_id") {
        const val = organization.salesforce_id
          ? organization.salesforce_id
          : "";
        result.push(val);
      }
      if (key === "full_name") {
        const val = organization.full_name ? organization.full_name : "";
        result.push(val);
      }
      if (key === "acronym_name") {
        const val = organization.acronym_name ? organization.acronym_name : "";
        result.push(val);
      }
      if (key === "state") {
        const val = organization.state ? organization.state : "";
        result.push(val);
      }
      if (key === "city") {
        const val = organization.city ? organization.city : "";
        result.push(val);
      }
      if (key === "account_name") {
        const val = organization.account_name ? organization.account_name : "";
        result.push(val);
      }
      if (key === "founding_year") {
        const val = organization.founding_year
          ? organization.founding_year
          : "";
        result.push(val);
      }
      if (key === "default_name") {
        const val = organization.default_name ? organization.default_name : "";
        result.push(val);
      }
      if (key === "colloquial_letters") {
        const val = organization.colloquial_letters
          ? organization.colloquial_letters
          : "";
        result.push(val);
      }
      if (key === "category") {
        const val = organization.category ? organization.category : "";
        result.push(val);
      }
    }

    if (prefix === "college") {
      if (!college) {
        continue;
      }
      if (key === "motto_short") {
        const val = college.motto_short ? college.motto_short : "";
        result.push(val);
      }
      if (key === "motto") {
        const val = college.motto ? college.motto : "";
        result.push(val);
      }
      if (key === "motto_long") {
        const val = college.motto_long ? college.motto_long : "";
        result.push(val);
      }
      if (key === "colloquial_phrase") {
        const val = college.colloquial_phrase ? college.colloquial_phrase : "";
        result.push(val);
      }
      if (key === "colloquial_name") {
        const val = college.colloquial_name ? college.colloquial_name : "";
        result.push(val);
      }
      if (key === "salesforce_id") {
        const val = college.salesforce_id ? college.salesforce_id : "";
        result.push(val);
      }
      if (key === "full_name") {
        const val = college.full_name ? college.full_name : "";
        result.push(val);
      }
      if (key === "acronym_name") {
        const val = college.acronym_name ? college.acronym_name : "";
        result.push(val);
      }
      if (key === "state") {
        const val = college.state ? college.state : "";
        result.push(val);
      }
      if (key === "city") {
        const val = college.city ? college.city : "";
        result.push(val);
      }
      if (key === "account_name") {
        const val = college.account_name ? college.account_name : "";
        result.push(val);
      }
      if (key === "founding_year") {
        const val = college.founding_year ? college.founding_year : "";
        result.push(val);
      }
      if (key === "default_name") {
        const val = college.default_name ? college.default_name : "";
        result.push(val);
      }
      if (key === "colloquial_letters") {
        const val = college.colloquial_letters
          ? college.colloquial_letters
          : "";
        result.push(val);
      }
      if (key === "category") {
        const val = college.category ? college.category : "";
        result.push(val);
      }
    }
  }

  return result.join("");
}

export function constructSizeTableHTML({ prices }: { prices: PriceType[] }) {
  const sorted = prices.sort((a, b) => a.position - b.position);
  let table = `<table><th>Sizes</th></tr><tbody>`;
  for (let i = 0; i < sorted.length; i++) {
    const price = prices[i];
    table += "<tr><td>" + price.size + "</td></tr>";
  }
  return table + "<tbody></table>";
}
